const selectors = {
  announcement: '[data-announcement-wrapper]',
  transparent: 'data-header-transparent',
  sectionOuter: '.theme-sticky-section',
  header: '[data-header-wrapper] header',
};

const classes = {
  stuck: 'js__header__stuck',
  stuckAnimated: 'js__header__stuck--animated',
  maskFirstAnimation: 'js__header__stuck--mask',
  triggerAnimation: 'js__header__stuck--trigger-animation',
  stuckBackdrop: 'js__header__stuck__backdrop',
};

let sections = {};

class Sticky {
  constructor(el) {
    this.wrapper = el;
    this.type = this.wrapper.dataset.headerSticky;
    this.transparent = this.wrapper.dataset.headerTransparent;
    this.sectionOuter = document.querySelector(selectors.sectionOuter);
    this.sticks = (this.type === 'sticky');
    this.animated = (this.type === 'directional');
    this.currentlyStuck = false;
    this.cls = this.sectionOuter.classList;
    const announcementEl = document.querySelector(selectors.announcement);
    const announcementHeight = announcementEl ? announcementEl.clientHeight : 0;
    const headerHeight = document.querySelector(selectors.header).clientHeight;
    this.threshhold = headerHeight + announcementHeight;
    if (this.sticks) {
      this.threshhold = announcementHeight;
      this.cls.add(classes.stuck);
      this.scrollDownInit();
    }
    this.listen();
  }
  unload() {
    document.removeEventListener('theme:scroll', this.listen);
    document.removeEventListener('theme:scroll:up', this.scrollUpDirectional);
    document.removeEventListener('theme:scroll:down', this.scrollDownDirectional);
  }
  listen() {
    if (this.sticks || this.animated) {
      document.addEventListener('theme:scroll', (e) => {
        if (e.detail.down && e.detail.position > this.threshhold) {
          if (!this.currentlyStuck) {
            this.stickSimple();
          }
        }
        if (e.detail.up && e.detail.position <= this.threshhold) {
          this.unstickSimple();
        }
      });
    }
    if (this.animated) {
      document.addEventListener('theme:scroll:up', this.scrollUpDirectional.bind(this));
      document.addEventListener('theme:scroll:down', this.scrollDownDirectional.bind(this));
    }
  }
  stickSimple() {
    if (this.animated) {
      this.cls.add(classes.maskFirstAnimation);
      this.cls.add(classes.stuckAnimated);
    }
    this.cls.add(classes.stuckBackdrop);
    this.cls.add(classes.stuck);
    this.wrapper.setAttribute(selectors.transparent, false);
    this.currentlyStuck = true;
  }
  unstickSimple() {
    this.cls.remove(classes.stuckBackdrop);
    this.cls.remove(classes.stuck);
    this.wrapper.setAttribute(selectors.transparent, this.transparent);
    if (this.animated) {
      this.cls.remove(classes.stuckAnimated);
    }
    this.currentlyStuck = false;
  }
  scrollDownInit() {
    if (window.scrollY > this.threshhold) {
      this.stickSimple();
    }
  }
  stickDirectional() {
    this.cls.remove(classes.maskFirstAnimation);
    this.cls.add(classes.triggerAnimation);
  }
  unstickDirectional() {
    this.cls.remove(classes.triggerAnimation);
  }
  scrollDownDirectional() {
    this.unstickDirectional();
  }
  scrollUpDirectional() {
    if (window.scrollY <= this.threshhold) {
      this.unstickDirectional();
    } else {
      this.stickDirectional();
    }
  }
}

const stickyHeader = {
  onLoad() {
    sections = new Sticky(this.container);
  },
  onUnload: function() {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

export default stickyHeader;
